﻿require("./_reply");
// 创建播放器
// var player = new DsFlashPlayer();
var recommendsPage = 0;
var cacheVideo = null;
var thumbnailPoster = "";
var playType = 1;

$(function () {
    var liveDays = "";
    for (var i = 6; i >= 0; i--) {
        var day = new Date().getDay() - i;
        if (day < 0) day += 7;

        if (i == 0) {
            liveDays += '<div class="live-day selected" data-value="0">今天</div>';
        } else if (day == 0) {
            liveDays += '<div class="live-day" data-value="' + -i + '">周日</div>';
        } else if (day == 1) {
            liveDays += '<div class="live-day" data-value="' + -i + '">周一</div>';
        } else if (day == 2) {
            liveDays += '<div class="live-day" data-value="' + -i + '">周二</div>';
        } else if (day == 3) {
            liveDays += '<div class="live-day" data-value="' + -i + '">周三</div>';
        } else if (day == 4) {
            liveDays += '<div class="live-day" data-value="' + -i + '">周四</div>';
        } else if (day == 5) {
            liveDays += '<div class="live-day" data-value="' + -i + '">周五</div>';
        } else if (day == 6) {
            liveDays += '<div class="live-day" data-value="' + -i + '">周六</div>';
        }
    }
    $(".live-days").html(liveDays);
    var type = $('.content').attr('data-type')
    getChannels(type);

    getChildColumn();

    $(".live-days").on("click", ".live-day", function () {
        $(".live-day").removeClass("selected");
        $(this).addClass("selected");
        getPlaylist();
    });

    // getReply();
});

$(window).scroll(function () {
    // 下面这句主要是获取网页的总高度，主要是考虑兼容性所以把Ie支持的documentElement也写了，这个方法至少支持IE8
    var htmlHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
    // clientHeight是网页在浏览器中的可视高度，
    var clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 通过判断滚动条的top位置与可视网页之和与整个网页的高度是否相等来决定是否加载内容；
    if (scrollTop + clientHeight >= htmlHeight) {
        getReply();
    }
});

function getChannels(type) {
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/channels",
        data: { type: type },
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                alert("获取频道列表失败:" + data.message);
                return;
            }
            var newlist = "";
            for (var i = 0; i < data.length; i++) {
                var info = data[i];
                newlist +=
                    '<div class="channel-item" data-value="' +
                    info.id +
                    '">' +
                    info.title +
                    "</div>\n";
            }

            $(".live-channel").append(newlist);

            $(".live-channel").on("click", ".channel-item", function () {
                $(".channel-item").removeClass("selected");
                $(this).addClass("selected");
                getPlaylist();
                var id = $(this).attr("data-value");
                channelPlay(id);

                replyPage = 1;
                $("#info_id").val(id);
                getReply();
            });

            var id = $("#info_id").val();
            if (id != "") {
                $('.channel-item[data-value="' + id + '"]').click();
            } else {
                $(".channel-item")[0].click();
            }
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function channelPlay(id) {
    if (!id) return;
    $(".live-player img").remove();
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/content?id=" + id,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                alert("获取频道信息错误:" + data.message);
                return;
            }
            if (
                !data ||
                !data.exdata ||
                !data.exdata.lives ||
                data.exdata.lives.length == 0
            ) {
                alert("获取直播扩展信息失败");
                console.log(data);
                return;
            }
            var obj = data.exdata.lives[0];
            var ads = data.adsdata;
            var urls = [];
            try {
                $("#content").removeClass("no-live");
                var playerId = "player_" + id;
                if (cacheVideo) {
                    cacheVideo.dispose();
                }

                if (obj.flv_url) {
                    urls.push(obj.flv_url);
                }
                if (obj.m3u8_url) {
                    urls.push(obj.m3u8_url);
                }
                if (obj.rtmp_url) {
                    urls.push(obj.rtmp_url);
                }
                if (urls.length > 0) {
                    playType = obj.type;
                    if (obj.type == 1) {
                        $("#content").html(
                            '<video id="' +
                            playerId +
                            '" style="min-width: 671px; min-height: 433px;"  class="video-js vjs-big-play-centered"></video>'
                        );
                        var config = {
                            urls: urls,
                            id: "content",
                            blive: true,
                            bchange: true,
                            ads: ads,
                        };
                        cacheVideo = startPlay(obj.m3u8_url, playerId, true, true);
                    } else if (obj.type == 2) {
                        $("#content").html(
                            '<audio id="' +
                            playerId +
                            '" style="min-width: 671px; min-height: 433px;"  class="video-js vjs-big-play-centered"></audio>'
                        );

                        // 达州电视台广播相当于 带封面的视频播放器，
                        var cover =
                            data.pc_poster_url
                                ? data.pc_poster_url
                                : "";
                        thumbnailPoster = cover;
                        cacheVideo = startPlay(obj.m3u8_url, playerId, true, true, cover);
                    }
                } else {
                    $("#content").addClass("no-live");
                }

                $(".link-column-list").html("");
                if (data.fields.link_column) {
                    getLinkColumn(data.fields.link_column);
                }
            } catch (e) {
                console.log(e);
                alert("获取直播详细信息失败");
                return;
            }
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function getLinkColumn(column) {
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/linkcolumn?id=" + column,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            var html = "";
            for (var i = 0; i < data.length; i++) {
                var info = data[i];
                html += '<div class="link-column-item" dataid="' + info.id + '">';
                if (info.icon_url) {
                    html +=
                        '<div class="link-column-icon"><img src="' +
                        info.icon_url +
                        '?w=174&h=120&s=1"></div>';
                } else {
                    html += '<div class="link-column-icon"></div>';
                }
                html += '<div class="link-column-name">' + info.name + "</div>";
                html += "</div>";
            }
            $(".link-column-list").html(html);

            $(".link-column-item").on("click", function () {
                var id = $(this).attr("dataid");
                location.href = ROOT + "/column/" + id;
            });
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function getDateStr(AddDayCount) {
    var dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount); // 获取AddDayCount天后的日期
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1; // 获取当前月份的日期
    var d = dd.getDate();
    if (m < 10) m = "0" + m;
    if (d < 10) d = "0" + d;
    return y + "-" + m + "-" + d;
}

function getPlaylist(livetime) {
    var channelId = $(".channel-item.selected").attr("data-value");
    if (!channelId) return;
    var day = $(".live-days .selected").attr("data-value");
    var start = getDateStr(parseInt(day));

    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/playlist?id=" + channelId + "&start=" + start,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                alert("操作失败:" + data.message);
                return;
            }
            var newlist = "";
            for (var d in data) {
                for (var i = 0; i < data[d].length; i++) {
                    var info = data[d][i];
                    if (livetime && parseInt(livetime) > parseInt(info.start_time))
                        continue;
                    if (info.type == "playback")
                        newlist +=
                            '<div class="live-item playback" playtime="' +
                            info.start_time +
                            '">\n';
                    else if (info.type == "live")
                        newlist +=
                            '<div class="live-item live" playtime="' +
                            info.start_time +
                            '">\n';
                    else if (info.type == "ready")
                        newlist +=
                            '<div class="live-item ready" playtime="' +
                            info.start_time +
                            '">\n';
                    else newlist += '<div class="live-item">\n';
                    newlist +=
                        '<div class="live-item-time">' + info.play_time + "</div>\n";
                    newlist += '<div class="live-item-title">' + info.name + "</div>\n";
                    if (info.type == "playback") {
                        newlist += '<div class="live-item-type playback">回看</div>\n';
                    } else if (info.type == "live")
                        newlist += '<div class="live-item-type live">直播</div>\n';
                    else if (info.type == "ready")
                        newlist += '<div class="live-item-type ready"></div>\n';
                    newlist += "</div>\n";
                }
            }

            if (!livetime) $(".live-list").html(newlist);
            else {
                $(".live-item.live").remove();
                $(".live-item.ready").remove();
                $(".live-list").append(newlist);
            }

            checkplaylist();

            $(".live-list").off("click", ".live-item");
            $(".live-list").on("click", ".live-item", function () {
                $(".live-item.playing .live-item-type").text("回看");
                $(".live-item.playing").removeClass("playing");
                if ($(this).hasClass("live")) {
                    playlive("");
                } else if ($(this).hasClass("playback")) {
                    $(this).children(".live-item-type").text("正在播出");
                    $(this).addClass("playing");

                    var playtime = $(this).attr("playtime");
                    playlive(playtime);
                }
            });
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function checkplaylist() {
    var next = $(".live-item.live").next();
    if (next.length == 0) return;
    var livetime = $(".live-item.live").attr("playtime");
    var start = getServerTime();
    var interval = parseInt(next.attr("playtime")) * 1000 - start;
    interval = 60000;
    setTimeout(getPlaylist, interval, livetime);
}

function getRecommends() {
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/contents?key=list&page=" + recommendsPage,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                alert("操作失败:" + data.message);
                return;
            }
            if (data.data === undefined) {
                alert("操作失败");
                return;
            }
            var newlist = "";
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                if (
                    info.thumbnail_urls === undefined ||
                    info.thumbnail_urls == null ||
                    info.thumbnail_urls == ""
                )
                    info.thumbnail_urls = [];
                if (info.type == 4) {
                    newlist += '<div class="newsItem">';
                    newlist += '<div class="news_body">';
                    newlist +=
                        '<a class="news_title" href="' +
                        info.url +
                        '" target="_blank">' +
                        info.title +
                        "</a>";
                    newlist += "</div>";
                    newlist += '<div class="newsPicture">';
                    for (var j = 0; j < info.thumbnail_urls.length; j++) {
                        if (j == 4) break;
                        newlist +=
                            '<a href="' +
                            info.url +
                            '" target="_blank"><img src="' +
                            info.thumbnail_urls[j] +
                            "?w=156&h=102&s=3" +
                            '"/></a>';
                    }
                    newlist += "</div>";
                    newlist += '<div class="news_info">';
                    newlist += '<div class="user">' + info.author_nickname + "</div>";
                    newlist += '<div class="time">' + info.publish_time + "</div>";
                    newlist += '<div class="reply">';
                    if (info.comment_count > 0)
                        newlist +=
                            '<div class="reply_count">' + info.comment_count + "评论</div>";
                    if (info.view_count > 0)
                        newlist +=
                            '<div class="reply_count">' + info.view_count + "浏览</div>";
                    newlist += "</div>";
                    newlist += "</div>";
                    newlist += "</div>";
                } else {
                    newlist += '<div class="newsItem">';
                    if (info.thumbnail_urls.length > 0) {
                        newlist += '<div class="newsPicture">';
                        newlist +=
                            '<a href="' +
                            info.url +
                            '" target="_blank"><img src="' +
                            info.thumbnail_urls[0] +
                            "?w=156&h=102&s=3" +
                            '"/></a>';
                        newlist += "</div>";
                    } else if (info.publisher_avatar_url) {
                        newlist += '<div class="newsPicture">';
                        newlist +=
                            '<a href="' +
                            info.url +
                            '" target="_blank"><img src="' +
                            info.publisher_avatar_url +
                            "?w=156&h=102&s=3" +
                            '"/></a>';
                        newlist += "</div>";
                    }
                    newlist += '<div class="alignMiddle">';
                    newlist += '<div class="newsInfo">';
                    newlist += '<div class="news_body">';
                    newlist +=
                        '<a class="news_title" href="' +
                        info.url +
                        '" target="_blank">' +
                        info.title +
                        "</a>";
                    newlist += "</div>";
                    newlist += '<div class="news_info">';
                    newlist += '<div class="user">' + info.author_nickname + "</div>";
                    newlist += '<div class="time">' + info.publish_time + "</div>";
                    newlist += '<div class="reply">';
                    if (info.comment_count > 0)
                        newlist +=
                            '<div class="reply_count">' + info.comment_count + "评论</div>";
                    if (info.view_count > 0)
                        newlist +=
                            '<div class="reply_count">' + info.view_count + "浏览</div>";
                    newlist += "</div>";
                    newlist += "</div>";
                    newlist += "</div>";
                    newlist += "</div>";
                    newlist += "</div>";
                }
            }

            $(".recommends-list").append(newlist);

            recommendsPage++;
            if (data.data.length < 5) $(".home-recommends .more").addClass("no-more");

            if ($(".newsItem").length == 0)
                $(".home-recommends").append(
                    '<div style="text-align: center;">暂无内容</div>'
                );
        },
        error: function (data) {
            console.log(data);
            // if (data.message !== undefined)
            //    alert('获取列表失败:' + data.message);
            // else
            //    alert('获取列表失败');
        },
    });
}

function getHots() {
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/contents?key=recommend",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                alert("操作失败:" + data.message);
                return;
            }
            if (data.data === undefined) {
                alert("操作失败");
                return;
            }
            var newlist = "";
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                if (
                    info.thumbnail_urls === undefined ||
                    info.thumbnail_urls == null ||
                    info.thumbnail_urls == ""
                )
                    info.thumbnail_urls = [];
                if (info.thumbnail_urls.length > 0) {
                    newlist += '<div class="hot-item">';
                    newlist +=
                        '<div class="hot-item-img"><a href="' +
                        info.url +
                        '" target="_blank"><img src="' +
                        info.thumbnail_urls[0] +
                        '?w=94&h=66&s=3"/></a></div>';
                    newlist += '<div style="width: 208px;height: 66px;float: right;">';
                    newlist +=
                        '<div class="hot-item-title"><a href="' +
                        info.url +
                        '" target="_blank">' +
                        info.title +
                        "</a></div>";
                    newlist +=
                        '<div class="hot-item-time">' + info.publish_time + "</div>";
                    newlist += "</div>";
                    newlist += "</div>";
                } else {
                    newlist += '<div class="hot-item">';
                    newlist += '<div style="width: 308px;height: 66px;float: right;">';
                    newlist +=
                        '<div class="hot-item-title"><a href="' +
                        info.url +
                        '" target="_blank">' +
                        info.title +
                        "</a></div>";
                    newlist +=
                        '<div class="hot-item-time">' + info.publish_time + "</div>";
                    newlist += "</div>";
                    newlist += "</div>";
                }
            }

            $(".hots-list .hot-items").append(newlist);
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function playlive(time) {
    var id = $(".channel-item.selected").attr("data-value");

    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/playlive?id=" + id + "&time=" + time,
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            /* 
                      data.currentTime是回放时间/当前时间
                   */
            if (data == "") return;
            if (data.message !== undefined) {
                alert("操作失败:" + data.message);
                return;
            }
            var playerId = "player_" + id;
            if (cacheVideo) {
                cacheVideo.dispose();
            }

            var url;
            var currentTime = data.currenttime;
            $.each(data.segments, function (i) {
                if (
                    data.segments[i].starttime <= currentTime &&
                    currentTime < data.segments[i].stoptime
                ) {
                    url = data.segments[i].playbackurl[0] || "";
                }
            });
            var length = data.segments.length;
            if (currentTime >= data.segments[length - 1].stoptime) {
                url = data.segments[length - 1].playbackurl[0];
            }

            if (playType === 2) {
                $("#content").html(
                    '<audio id="' +
                    playerId +
                    '" style="min-width: 671px; min-height: 433px;"  class="video-js vjs-big-play-centered"></audio>'
                );
                if (!thumbnailPoster)
                    thumbnailPoster = require("../images/dzradio.jpg");
                cacheVideo = startPlay(url, playerId, true, true, thumbnailPoster);
            } else {
                $("#content").html(
                    '<video id="' +
                    playerId +
                    '" style="min-width: 671px; min-height: 433px;"  class="video-js vjs-big-play-centered"></video>'
                );
                cacheVideo = startPlay(url, playerId, true, true);
            }
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function getChildColumn() {
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/childcolumn?id=tv",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }

            var newlist = "";
            for (var i = 0; i < data.length; i++) {
                var info = data[i];
                newlist += '<div class="child-column-item">';
                newlist +=
                    '<a href="' +
                    ROOT +
                    "/column/" +
                    info.id +
                    '" target="_blank" class="child-column-img">';
                newlist += '<img src="' + info.icon_url + '?w=174&h=120&s=3"></a>';
                newlist +=
                    '<a href="' +
                    ROOT +
                    "/column/" +
                    info.id +
                    '" target="_blank" class="child-column-name">' +
                    info.name +
                    "</a>";
                newlist += "</div>";
            }

            $(".child-column-list").html(newlist);
        },
        error: function (data) {
            console.log(data);
        },
    });
}
